/* eslint-disable */
import lightGreen from "@material-ui/core/colors/lightGreen";
//import { BasfThemeOptions } from "./types";
import { Overrides } from "@material-ui/core/styles/overrides";
import { ThemeOptions, Theme } from "@material-ui/core";

// #F2F5F3 - отмеченный фон
// #2B3940; op 0.3 - неактивный текст

export const createBASFMainTheme = (): ThemeOptions => ({
  palette: {
    type: "light",
    common: {
      black: "#000",
      white: "#fff",
    },
    primary: {
      main: "#65AC1E",
      light: "#76d89c",
      dark: "#4c8a0f",
      contrastText: "#fff",
      50: "rgba(28, 169, 83, 0.01)",
    },
    secondary: {
      main: "#004a96",
      light: "#21a0d2",
      dark: "#003b78",
      contrastText: "#fff",
    },
    action: {
      // disabled: "",
      // disabledBackground: "",
      // active: "",
      // hover: "",
      selected: "#f2f5f3",
    },
    text: {
      primary: "#000",
      secondary: "#fff",
      // disabled: "",
      // hint: "",
    },
    // background: {
    //     default: "",
    //     paper: "",
    // },
  },
  typography: {
    fontFamily: ["Lato", "sans-serif"].join(","),
    h1: {
      fontSize: "3rem",
    },
    htmlFontSize: 14,
    fontSize: 14,
  },
});

export const createBASFOverridesTheme = (theme: Theme): Overrides => ({
  MuiButton: {
    root: {
      borderRadius: "3px",
      "&.MuiButton-textPrimary": {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common!.white,
      },
      "&.MuiButton-textPrimary:hover": {
        backgroundColor: theme.palette.primary.dark,
      },
    },
  },
});

export const createBASFTheme = (): ThemeOptions => {
  const mainPart = createBASFMainTheme();
  return {
    ...mainPart,
    overrides: createBASFOverridesTheme(mainPart as Theme),
  };
};
